module.exports = __webpack_public_path__ + "static/media/scpc.8c04e234.png";